import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { AnimatePresence } from 'motion/react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { marcarMomento, puedeVerseMomento } from '../animaciones/momentos-unicos';
import { esEmpresaDemo } from '../empresa-demo';
import { usePlanCompleto } from '../plan-completo-store';
import { CapaDeMomento } from './capa-de-momento';
import { ParteDelPlanCompleto } from './parte-del-plan-completo';
import { PlanConvertido } from './plan-convertido';

/** Lo que mide el cuadro a cada lado del centro, más su separación y los 300 px del panel. */
const ANCHO_PARA_EL_PANEL = 1100;

/** El cuadro del plan completo encima de la pantalla actual. «Seguir probando» lo cierra. */
export function DialogoDelPlanCompleto({
  abierto,
  alCambiar,
}: {
  abierto: boolean;
  alCambiar: (abierto: boolean) => void;
}) {
  // Momento 5: la primera vez, un panel al costado. El cuadro no cambia en nada.
  const [conEscena, setConEscena] = useState(false);
  useEffect(() => {
    setConEscena(
      abierto && window.innerWidth >= ANCHO_PARA_EL_PANEL && puedeVerseMomento('plan-prueba')
    );
  }, [abierto]);

  return (
    <>
      <Dialog open={abierto} onOpenChange={alCambiar}>
        <DialogContent
          className="max-w-md border-0 bg-transparent p-0 shadow-none"
          aria-describedby={undefined}
        >
          <ParteDelPlanCompleto alSeguir={() => alCambiar(false)} />
        </DialogContent>
      </Dialog>
      {/* Afuera del cuadro: `DialogContent` recorta lo que le sobresale. */}
      {createPortal(
        <AnimatePresence>
          {conEscena && (
            <CapaDeMomento
              momento="plan-prueba"
              className="fixed left-[calc(50%+14.75rem)] top-[calc(50%-120px)] z-[60]"
              alListo={() => marcarMomento('plan-prueba')}
              alCerrar={() => setConEscena(false)}
            />
          )}
        </AnimatePresence>,
        document.body
      )}
    </>
  );
}

/** El de toda la app (menú y direcciones bloqueadas). El cuadro sólo existe en una empresa demo. */
export function DialogoDelPlanCompletoGlobal() {
  const abierto = usePlanCompleto((s) => s.abierto);
  const cerrar = usePlanCompleto((s) => s.cerrar);
  return (
    <>
      {/* Va siempre: la empresa recién convertida ya no es demo. */}
      <PlanConvertido />
      {esEmpresaDemo() && (
        <DialogoDelPlanCompleto
          abierto={abierto}
          alCambiar={(a) => {
            if (!a) cerrar();
          }}
        />
      )}
    </>
  );
}
